import { useNavigate } from "react-router-dom";

const ServiceCard = () => {
  const navigate = useNavigate()
  return (
    <div className="w-full h-full flex flex-col gap-8 md:gap-[2vw] bg-transparent text-black relative z-10">
      <div className="w-full h-full md:h-[18vw] flex flex-col md:flex-row gap-8 md:gap-[4vw]">
        <div className="w-full md:w-[40%] min-h-[40vh] md:h-full md:min-h-0 flex flex-col gap-4 md:gap-[1vw] text-white overflow-hidden border-[0.2vw] border-white rounded-2xl md:rounded-[2vw] p-4 md:p-[2vw] items-center md:items-start">
          <h1 className="text-5xl md:text-[4vw] md:leading-[4.5vw] font-bold text-center md:text-start">
            Services Provided
          </h1>
          <button onClick={()=> navigate("/services#here")}
           className="bg-[#2b9fb4] hover:bg-[#2b9fb4]/80 text-blue-900 h-12 text-md w-40 md:w-[12vw] md:h-[4vw] rounded-full md:text-[1.25vw] ">
            Explore All
          </button>
        </div>

        <div className="w-full md:w-[30%] min-h-[30vh] md:h-full md:min-h-0 relative overflow-hidden rounded-2xl md:rounded-[2vw] bg-white">
          <img
            src="/Home/sp_1_raw.webp"
            alt="img"
            className="w-full h-full object-cover"
          />
          <p className="absolute bottom-[1vw] left-[1vw] text-2xl md:text-[1.6vw] font-bold">
            Veneers
          </p>
        </div>

        <div className=" w-full md:w-[30%] min-h-[30vh] md:h-full md:min-h-0 relative overflow-hidden rounded-2xl md:rounded-[2vw] bg-white">
          <img
            src="/Home/sp_2_raw.webp"
            alt="img"
            className="w-full h-full object-cover"
          />
          <p className="absolute bottom-[1vw] left-[1vw] text-2xl md:text-[1.6vw] font-bold">
            Smile Design
          </p>
        </div>
      </div>

      <div className="w-full h-full md:h-[18vw] flex gap-8 md:gap-[4vw] flex-col md:flex-row">
        <div className="w-full md:w-[30%] min-h-[30vh] md:h-full md:min-h-0 relative overflow-hidden rounded-2xl md:rounded-[2vw] bg-white">
          <img
            src="/Home/sp_3_raw.webp"
            alt="img"
            className="w-full h-full object-cover"
          />
          <p className="absolute bottom-[1vw] left-[1vw] text-2xl md:text-[1.6vw] font-bold">
            Digital Model
          </p>
        </div>
        <div className=" w-full md:w-[40%] min-h-[30vh] md:h-full md:min-h-0 relative overflow-hidden rounded-2xl md:rounded-[2vw] bg-white">
          <img
            src="/Home/sp_4_raw.webp"
            alt="img"
            className="w-full h-full object-contain"
          />
          <p className="absolute bottom-[1vw] left-[1vw] text-2xl md:text-[1.6vw] font-bold">
            Full Contour Crown
          </p>
        </div>
        <div className="w-full md:w-[30%] min-h-[30vh] md:h-full md:min-h-0 relative overflow-hidden rounded-2xl md:rounded-[2vw] bg-white">
          <img
            src="/Home/sp_5_raw.webp"
            alt="img"
            className="w-full h-full object-cover"
          />
          <p className="absolute bottom-[1vw] left-[1vw] text-2xl md:text-[1.6vw] font-bold">
            Custom Abutment
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
